import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
 
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Badge,
  Tooltip,
} from "reactstrap";
import classnames from "classnames";
import { useParams } from "react-router";
import { authHeader } from "../../../functions/CoreFunctions";
import {
  GET_USER,
  CUSTOMER_LICENCE_LISTING_URL,
  GET_PAYMENT,
} from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { useNavigate, Link } from "react-router-dom";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";
import Pagination from "react-js-pagination";
import BackButtonSvg from "../../common/BackButtonSvg";
import { Info } from "../../common/Info";

function CustomerDetails(props) {
  const [activeTab, setActiveTab] = useState("1");
  const { userId } = useParams();
  const history = useNavigate();
  const [details, setDetails] = useState({});
  const [licensetotalrecords, setlicensetotalrecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [licenseDetails, setlicenseDetails] = useState([]);
  const [currentpage, setCurrentPage] = useState(0);
  const [paymentCurrentpage, setpaymentCurrentpage] = useState(0);
  const [paymentDetails, setpaymentDetails] = useState([]);
  const [paymentDetailsCount, setpaymentDetailsCount] = useState(0);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  let GetUser = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_USER,
      headers: authHeader(),
      params: {
        userId: userId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setDetails(data);
      }
    } catch (error) {
  
        
      
    } finally {
      setLoading(false);
    }
  };

  let GetCustomer = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: CUSTOMER_LICENCE_LISTING_URL,
      headers: authHeader(),
      params: {
        userId: userId,
        offset: currentpage,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setlicenseDetails(data);
        setlicensetotalrecords(totalCount);
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  let GetPayment = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_PAYMENT,
      headers: authHeader(),
      params: {
        userId: userId,
        offset: paymentCurrentpage,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setpaymentDetails(data);
        setpaymentDetailsCount(totalCount);
      }
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const Back = () => {
    history(-1);
  };
  let Profile = () => {
    if (details.profileImage) {
      return details.profileImage;
    } else {
      return defaultAvatar;
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const onPaymentPageChange = (page) => {
    setpaymentCurrentpage(page - 1);
  };

  useEffect(() => {
    GetUser();
    GetCustomer();
    GetPayment();
  }, []);

 

  return (
    <div>
      {loading && <CustomPageLoading />}
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>Customer Details</h4>

            <div className="top-btn">
              <Button onClick={Back} color="primary">
                <BackButtonSvg />
                Back
              </Button>
            </div>
          </div>

          <Row className="mt-4">
            <Col xl="5">
              <Row>
                <Col md="12">
                  <Card body>
                    <div className="customer-name">
                      <img src={Profile()} alt=""/>

                      <div className="name">
                        <h4>
                          {details.firstName} {details.lastName}
                        </h4>
                        <Badge color="primary">{details.email}</Badge>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col md="12">
                  <Card body>
                    <div className="customer-personal-info">
                      <Row>
                        <Col md="6">
                          <div className="info">
                            <span>FIRST NAME</span>
                            <p>
                              {details.firstName ? details.firstName : "N/A"}
                            </p>
                          </div>

                          <div className="info">
                            <span>EMAIL</span>
                            <p>{details.email ? details.email : "N/A"}</p>
                          </div>

                          <div className="info">
                            <span>GENDER</span>
                            <p>{details.gender ? details.gender : "N/A"}</p>
                          </div>

                          <div className="info">
                            <span>ADDRESS</span>
                            <p>{details.address ? details.address : "N/A"}</p>
                          </div>

                          <div className="info">
                            <span>STATE</span>
                            <p>
                              {details.stateName ? details.stateName : "N/A"}
                            </p>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="info">
                            <span>LAST NAME</span>
                            <p>{details.lastName ? details.lastName : "N/A"}</p>
                          </div>
                          <div className="info">
                            <span>PHONE</span>
                            <p>
                              {details.phoneNumber
                                ? `+1 ${details.phoneNumber}`
                                : "N/A"}
                            </p>
                          </div>
                          <div className="info">
                            <span>DOB</span>
                            <p>
                              {(details.dateOfBirth === "01/01/1900"
                                ? "N/A"
                                : details.dateOfBirth) || "N/A"}
                            </p>
                          </div>
                          <div className="info">
                            <span>CITY</span>
                            <p>{details.city ? details.city : "N/A"}</p>
                          </div>
                          <div className="info">
                            <span>ZIP</span>
                            <p>{details.zip ? details.zip : "N/A"}</p>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-5">
                        <Col sm="6" className="user-dash-count border-right">
                          <div className="bg">
                            <p>Total License</p>
                            <div className="count">
                              <h4>{details.totalLicense || 0}</h4>
                            </div>
                          </div>
                        </Col>
                        <Col sm="6" className="user-dash-count">
                          <div className="bg">
                            <p>Total Paid Amount</p>
                            <div className="count">
                              <h4>
                                {parseInt(details.totalPaidAmount || 0).toFixed(
                                  2
                                )}{" "}
                                $
                              </h4>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
                <Col md="12"></Col>
              </Row>
            </Col>

            <Col xl="7">
              <div>
                <Nav tabs className="mt-lg-4">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      Licence
                      <Tooltip
                        isOpen={id === "licesce" && tooltipOpen}
                        target={"licesce"}
                        toggle={() => tooltiptoggle("licesce")}
                      >
                        View customer license type
                      </Tooltip>
                      <span id={"licesce"}>
                        <Info />
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      Transaction
                      <Tooltip
                        isOpen={id === "transaction" && tooltipOpen}
                        target={"transaction"}
                        toggle={() => tooltiptoggle("transaction")}
                      >
                        View customer transaction history
                      </Tooltip>
                      <span id={"transaction"}>
                        <Info />
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Card body className="mt-4">
                      <Row>
                        {licenseDetails.length === 0 ? (
                          <center>No Records Found</center>
                        ) : (
                          <>
                            {licenseDetails.map((lic) => (
                              <Col md="6" lg="6" xl="6" className="mb-3">
                                <div className="license-box">
                                  <h4>{lic.typeofLicense}</h4>

                                  <div className="mt-4">
                                    <div>
                                      <div className="row align-items-center">
                                        <div className="col">
                                          <h6 className="text-sm mb-0">
                                            validate from
                                          </h6>
                                        </div>
                                        <div class="col-auto">
                                          <span className="text-sm">
                                            {" "}
                                            {lic.validFromDate
                                              ? lic.validFromDate
                                              : "N/A"}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="my-2" />
                                      <div className="row align-items-center">
                                        <div className="col">
                                          <h6 className="text-sm mb-0">
                                            validate To
                                          </h6>
                                        </div>
                                        <div class="col-auto">
                                          <span className="text-sm">
                                            {" "}
                                            {lic.validToDate
                                              ? lic.validToDate
                                              : "N/A"}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="my-2" />
                                      <div className="row align-items-center">
                                        <div className="col">
                                          <h6 className="text-sm mb-0">
                                            Created date
                                          </h6>
                                        </div>
                                        <div className="col-auto">
                                          <span className="text-sm">
                                            {" "}
                                            {lic.createdDate
                                              ? lic.createdDate
                                              : "N/A"}
                                          </span>
                                        </div>
                                      </div>
                                      <hr className="my-2" />
                                    </div>
                                  </div>

                                  <Badge
                                    className={
                                      lic.licenseStatus === "License Issued"
                                        ? "badge-pay-complete"
                                        : lic.licenseStatus === "Pending"
                                        ? "badge-success-pen"
                                        : lic.licenseStatus ===
                                          "License Approved"
                                        ? "badge-success-apr"
                                        : lic.licenseStatus === "Rejected"
                                        ? "badge-danger-soft"
                                        : lic.licenseStatus ===
                                          "Payment Completed"
                                        ? "badge-primary-soft"
                                        : lic.licenseStatus ===
                                          "License Generated"
                                        ? "badge-success-gen"
                                        : lic.licenseStatus === "Cancelled"
                                        ? "badge-danger-soft"
                                        : ""
                                    }
                                  >
                                    {lic.licenseStatus}
                                  </Badge>
                                  <div className="centerBtn">
                                    <Link
                                      to={{
                                        pathname: `${"/agency/view-license"}/${
                                          lic.licensePlanId
                                        }/${lic.dogLicenseId}`,
                                      }}
                                    >
                                      <Button
                                        className="action-item"
                                        color="primary"
                                        size="sm"
                                      >
                                        View
                                      </Button>
                                    </Link>
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </>
                        )}
                      </Row>
                    </Card>
                    <div className="d-flex flex-row py-4 justify-content-end">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={currentpage + 1}
                        itemsCountPerPage={10}
                        totalItemsCount={licensetotalrecords}
                        onChange={onPageChange}
                      />
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <Card body className="mt-4">
                      {paymentDetails.length === 0 ? (
                        <center>No Records Found</center>
                      ) : (
                        <Table hover responsive>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Plan Name</th>
                              <th>Date</th>
                              <th>Payment Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paymentDetails.map((pay, index) => (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{pay.planName}</td>
                                <td>{pay.paymentDate}</td>
                                <td>
                                  ${" "}
                                  {parseFloat(pay.totalAmount || 0).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </Card>
                    <div className="d-flex flex-row py-4 justify-content-end">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={paymentCurrentpage + 1}
                        itemsCountPerPage={10}
                        totalItemsCount={paymentDetailsCount}
                        onChange={onPaymentPageChange}
                      />
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default CustomerDetails;
